import { Alert } from '@mui/material';

interface StructuralConflictBannerProps {
  message: string;
}

const StructuralConflictBanner = ({
  message,
}: StructuralConflictBannerProps) => {
  return (
    <Alert severity="error" role="alert" sx={{ mb: 2 }}>
      {message}
    </Alert>
  );
};

export default StructuralConflictBanner;
